import { AppState } from '../../index';
import { STATE_KEY } from './constants';
import { Fundraiser, FundraiserState } from './model';

const selectFundraiser = (state: AppState): FundraiserState => state[STATE_KEY];
export const selectFundraiserRequestInFlight = (state: AppState): boolean => selectFundraiser(state).status.inFlight;
export const selectFundraiserRequestSuccess = (state: AppState): boolean => selectFundraiser(state).status.success;
export const selectFundraiserData = (state: AppState): Fundraiser => selectFundraiser(state).fundraiser;
export const selectFundraisers = (state: AppState): Fundraiser[] => selectFundraiser(state).fundraiserList;
